import { Link } from "react-router-dom";

const Navbar = () => {
    const nav_title = '<Programmer>'
    return ( 
        <nav className="navbar">
            {/* <h1>{nav_title}</h1> */}
            <div className="links">
                <Link to="/">Home</Link>
                <Link to="./projects">Projects</Link>
                {/* <Link to="./contact">Contact</Link> */}
            </div>
            {/* <hr /> */}
        </nav>
     );
}
 
export default Navbar;